import { render, staticRenderFns } from "./task-selector.vue?vue&type=template&id=6949fa15&scoped=true&"
import script from "./task-selector.vue?vue&type=script&lang=ts&"
export * from "./task-selector.vue?vue&type=script&lang=ts&"
import style0 from "./task-selector.vue?vue&type=style&index=0&id=6949fa15&prod&lang=scss&scoped=true&"
import style1 from "./task-selector.vue?vue&type=style&index=1&id=6949fa15&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6949fa15",
  null
  
)

export default component.exports